import { render, staticRenderFns } from "./Water.vue?vue&type=template&id=39fdb573&"
import script from "./Water.vue?vue&type=script&lang=js&"
export * from "./Water.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports